import React, { Component } from "react";
import Select, { components } from "react-select";
import "./CustomerFormStyle.css";
import { AiFillCaretDown } from "react-icons/ai";
import Astreix from "./Astreix";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <AiFillCaretDown />
    </components.DropdownIndicator>
  );
};

export default function DropDown({
  data,
  label,
  handleChange,
  handleBlur,
  value,
  name,
  disable=false
}) {
  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };

  const NewlineText=()=> {
   const newText = label.split("'").map((str,i) => {
  return (
    <p
      style={{
        paddingBottom: "0",
        marginBottom: i === 0 ? "" : "5px",
        marginTop: i === 0 ? "-1px" : "-23px",
        fontSize: i === 0 ? "" : value ? "0px" : "10px",
      }}
    >
      {i === 0 ? <Astreix label={str} /> : str}
    </p>
  );})

    return newText;
  }


  return (
    <Select
      isSearchable={false}
      isDisabled={disable}
      className="dropdown"
      name={name}
      options={data}
      getOptionLabel={(option) => `${option.localizedLabel}`}
      value={
        disable && name !== "currentOccupation"
          ? "0"
          : defaultValue(data, value)
      }
      isClearable={false}
      components={{
        ValueContainer: CustomValueContainer,
        DropdownIndicator,
        IndicatorSeparator: () => null,
      }}
      onChange={(value) => {
        handleChange(value);
      }}
      onBlur={handleBlur}
      placeholder={
        name === "modeOfIncome" ? NewlineText() : <Astreix label={label} />
      }
      styles={{
        container: (provided, state) => ({
          ...provided,
          backgroundColor: disable ? "#E8E8E8" : "#FFFFFF",
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          overflow: "visible",
          marginLeft: "8px",
          fontSize: "16px",
          marginTop: value ? "-4px" : "-15px",
          paddingTop: "5px",
        }),
        placeholder: (provided, state) => ({
          ...provided,
          position: "absolute",
          top: state.hasValue || state.selectProps.inputValue ? -20 : "0%",
          transition: "top 0.1s, font-size 0.1s",
          fontSize: (state.hasValue || state.selectProps.inputValue) && 13,
          color: disable ? "grey" : "#999999",
        }),
        control: (base) => ({
          ...base,
          border: 0,
          boxShadow: "none",
          backgroundColor: disable ? "transparent" : "white",
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:  isFocused ? "#6C63FF" : "#fff",
            color: isFocused ? "#FFF" : "#333333",
            zIndex: 10,
          };
        },
      }}
    />
  );
}
